const defaultFileObject = {
	files: [],
}

const storageWebpage = '153600' //150K

function normalizeLocalFiles(data) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.map(file => ({
		size: file.size,
		name: file.name,
		link: file.preview,
		file: data,
		type: 'local',
	}))
	return fileObject
}

function normalizeDriveFiles(files, token) {
	const fileObject = {...defaultFileObject}
	fileObject.files = files.filter(file => file.statusCode === 200).map(file => {
		let url = file.body.downloadUrl
		let name = file.body.title
		if (file.body.exportLinks) {
			url = file.body.exportLinks['application/pdf']
			name = `${name}.pdf`
		}
		return {
			size: file.body.fileSize,
			name,
			link: url,
			type: 'drive',
			token,
			mimeType: file.body.mimeType,
		}
	})
	return fileObject
}

function normalizeDropboxFiles(data) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.map(file => ({
		size: file.bytes,
		name: file.name,
		link: file.link,
		type: 'dropbox',
	}))
	return fileObject
}

function normalizeOneDriveFiles(data) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.value.map(file => ({
		size: file['size'],
		name: file['name'],
		link: file['@microsoft.graph.downloadUrl'],
		type: 'onedrive',
	}))
	return fileObject
}

function normalizeWebContent(data) {
	const fileObject = {...defaultFileObject}
	fileObject.files = [{
		size: storageWebpage,
		link: data,
		name: data,
		type: 'web',
	}]
	return fileObject
}

function normalizeImageSearchFiles(data, source) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.map(file => ({
		size: file.size,
		name: file.title,
		link: file.link,
		type: source,
	}))
	return fileObject
}

function normalizeGifSearchFiles(data, source) {
	return normalizeImageSearchFiles(data, source)
}

function normalizeVideoSearchFiles(data, source) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.map(file => ({
		size: file.size,
		name: file.title,
		link: file.link,
		id: file.videoId,
		type: source,
	}))
	return fileObject
}

function normalizeRecordFiles(data, trimData) {
	const fileObject = {...defaultFileObject}
	fileObject.files = data.map(file => ({
		size: file.size,
		name: 'local_audio.ogg',
		link: file.preview,
		file: data,
		trim: trimData,
		fileName: 'local_audio.ogg',
		type: 'audio_recorder',
	}))
	return fileObject
}

export {
	normalizeLocalFiles,
	normalizeDriveFiles,
	normalizeDropboxFiles,
	normalizeOneDriveFiles,
	normalizeWebContent,
	normalizeImageSearchFiles,
	normalizeGifSearchFiles,
	normalizeVideoSearchFiles,
	normalizeRecordFiles,
}
